import type { MaybeRef } from 'vue'

import { IMediaType } from '~/entities/content/media/interfaces/media-type'

import { getSwymUrl } from '~/features-shared/config-manager/stores/swym-config'

const mediaThumb = {
  [IMediaType.Picture]: 'pic',
  [IMediaType.Document]: 'doc',
  [IMediaType.Video]: 'vid',
  [IMediaType.Sound]: 'sound',
  [IMediaType.Model3D]: '3D',
  [IMediaType.Sketch]: 'drawing',
  [IMediaType.Story]: 'drawing',
  [IMediaType.Whiteboard]: 'drawing',
  [IMediaType.Simulation]: '3D',
  [IMediaType.AnimatedPicture]: 'pic',
  [IMediaType.Drawing]: 'drawing',
  [IMediaType.HomeByMe]: 'drawing',
}

/**
 * Return the default media thumbnail for a given media type
 * @param mediaType the media type, @see IMediaType
 * @param path the base path for resolution, @default "media-default-thumb/xl_thumb_default_"
 */
export function useMediaThumb(
  mediaType: MaybeRef<IMediaType>,
  path: MaybeRef<string> = 'media-default-thumb/xl_thumb_default_',
) {
  const swymUrl = getSwymUrl()
  return computed(() => {
    return `${swymUrl}/webapps/SwymVueWeb/assets/${toValue(path)}${mediaThumb[toValue(mediaType)]}.png`
  })
}
